export const AccedoOneMembershipTags = {
  LevelAdmin: { 'one:access:level': 'admin' },
};

export const AccedoProduct = { AccedoOne: 'one', Appgrid: 'appgrid' };

const config = {
  csrf: 'N/A',
  accedoOneSdk: {
    appKey: '58d8c0c7812a4f02195e5b7d',
  },
};

export const TITLE = 'Accedo';
export const TITLE_CONTROL = 'Accedo Control';
export default config;



// WEBPACK FOOTER //
// ./src/client/src/config.js